import { Config } from "../config/Config";
import firebase from "../utilities/Firebase";

/**
 * ロギングサービス
 */
export const LoggingService = () => {
  /**
   * Cloud Functions のログ収集関数を呼び出す
   * @param user ユーザーID
   * @param error エラー情報
   */
  const logging = async (user: string, error: Error) => {
    try {
      await firebase
        .functions("asia-northeast1")
        .httpsCallable("frontendLogging")({
        env: Config.appEnv,
        message: JSON.stringify({
          user,
          userAgent: window.navigator.userAgent,
          errorName: error.name,
          errorMessage: error.message,
          errorStack: error.stack,
        }),
      });
    } catch (err) {
      // ログ収集サービスの呼び出し失敗は無視する
      console.log(err);
    }
  };

  return { logging };
};
